const closeButtonLabel = "Aizvērt";
const lvLV = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  lvLV as default
};
